import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import './index.css';
import './lib/iconify-bundle';
import reportWebVitals from './reportWebVitals';



const Root = () => {
    const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
    const [showInstallPrompt, setShowInstallPrompt] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (event: any) => {
            event.preventDefault();
            setDeferredPrompt(event);
            setShowInstallPrompt(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult: any) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('El usuario acept� la instalaci�n');
                } else {
                    console.log('El usuario rechaz� la instalaci�n');
                }
                setDeferredPrompt(null);
                setShowInstallPrompt(false);
            });
        }
    };

    const handleCancel = () => {
        setShowInstallPrompt(false);
    };

    return (
        <>
            <App />
            {showInstallPrompt && (
                <div className="fixed bottom-6 left-6 z-[1000] max-w-xs">
                    <div className="bg-[#342f6d] border border-white/10 rounded-2xl p-5 shadow-2xl shadow-black/40">
                        <div className="flex flex-col items-center gap-3">
                            <img src="logo192.png" alt="Scalar" className="w-16 h-16" />
                            <p className="text-white/80 text-sm text-center leading-relaxed">¡Agrega esta aplicación a tu pantalla de inicio!</p>
                            <div className="flex gap-3 w-full">
                                <button onClick={handleInstallClick} className="flex-1 px-4 py-2.5 bg-[#f26724] text-white font-semibold text-sm rounded-xl hover:bg-[#f3823c] transition-all">
                                    Instalar
                                </button>
                                <button onClick={handleCancel} className="flex-1 px-4 py-2.5 bg-white/10 text-white/70 font-medium text-sm rounded-xl hover:bg-white/20 transition-all">
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <HelmetProvider>
        <Root />
    </HelmetProvider>
);

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js', { type: 'module' })
            .then((registration) => {
                console.log('Service Worker registrado:', registration);
            })
            .catch((error) => {
                console.log('Error al registrar el Service Worker:', error);
            });
    });
}


reportWebVitals();
